export const LogConfig = {
  ActionLog: {
    enable: true,
  },
  ErrorLog: {
    enable: true,
  },
  maxCachedItems: 50,
  maxTimeout: 30000
};
